<template>
  <component :is="pageComponent" />
</template>

<script>
import PcGoods from "@/views/pc/goods/index.vue";
import MGoods from "@/views/mobile/goods/index.vue";
import { isMobile } from "@/utils/device";

export default {
  name: "GoodsBridge",
  computed: {
    pageComponent() {
      return isMobile() ? MGoods : PcGoods;
    },
  },
};
</script>
